import { makeLegendFormatter } from '../utils/legend-formatter.js'
import { dateFormatterInit } from '../utils/date-formatter.js'

const vocChartOptions = {
  height: 320,
  labels: [
    'Datetime',
    'VOC Index'
  ],
  series: {
    'VOC Index': {
      axis: 'y'
    }
  },
  axes: {
    x: dateFormatterInit(),
    y: {
      valueRange: [0, 500],
      axisLabelWidth: 50,
      independentTicks: true,
      axisLabelFormatter: (y) => y.toFixed(0)
    }
  },
  colors: ['#9B59B6'],
  labelsDiv: 'legendDivVOC',
  labelsSeparateLines: false,
  legend: 'always',
  legendFormatter: makeLegendFormatter((data) => {
    return data
  }),
  animatedZooms: true
}

export {
  vocChartOptions
}